import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5856b0b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "idente" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" 1.身份赋予API可以在客户在直播时，指定观众以特定身份观看直播，如将自身平台的观众身份传递到直播 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("  页面，让观众获得无缝的体验； "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("2.特别说明：如果您选用了此API，那么微信打赏，付费观看，红包雨，红包等涉及微信的功能将暂不可用； "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("3.为了跳回当前直播间，我们给可以给您传送必要的参数直播间ID(studio_id)，您可以填入： "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("  (您的页面完整地址)加上参数拼接即可： "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("   ?studio_id={studio_id}&auth_key={auth_key}， "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("   如：http://www.baidu.com?studio_id={studio_id}&auth_key={auth_key}（注：符号为英文半角符号）。 "),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_3 = { class: "idente_mar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "保存成功后生成 Auth Key", -1))
const _hoisted_5 = ["data-clipboard-text"]
const _hoisted_6 = { class: "worp_swt" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "【身份赋予】 与 【报名观看】会造成用户身份冲突，二者不能同时开启。", -1))

import { computed } from 'vue';
import { Input, Radio, Popover, message } from 'ant-design-vue';
import { useStore } from 'vuex';
import { QuestionCircleFilled } from '@ant-design/icons-vue';
import ClipboardJS from 'clipboard';

//  授权观看 -----身份赋予
const __default__ = { name: 'IdentityGrant' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const form = computed(() => store.state.authorizView.idView);
const updateForm = (type: number) => {
  if (form.value.idGiveSwitch) {
    message.destroy();
    if (!type) store.commit('authorizView/chaeckSwitch');
    store.commit('authorizView/updateChildSwitch');
  }
  store.commit('authorizView/updateIdForm', form.value);
};
const aInput = Input;
const aRadioGroup = Radio.Group;
const aPopover = Popover;
// const checked = ref<boolean>(false);
const Copylist = (btns: any) => {
  let ClipboardJSObj = new ClipboardJS(btns);
  // // let ClipboardJSObj2 = new ClipboardJS('.text_btns');
  ClipboardJSObj.on('success', function (e) {
    message.destroy();
    message.info('复制成功');
    e.clearSelection();
  });
  ClipboardJSObj.on('error', function () {
    message.destroy();
    message.info('复制失败');
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_switch = _resolveComponent("a-switch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(" 自定义链接地址： "),
      _createVNode(_unref(aInput), {
        value: _unref(form).callback,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).callback) = $event)),
        class: "idente_input",
        id: "warrants",
        onInput: _cache[1] || (_cache[1] = ($event: any) => (updateForm(1)))
      }, null, 8, ["value"]),
      _createVNode(_unref(aPopover), {
        placement: "bottom",
        class: "idente_but"
      }, {
        content: _withCtx(() => [
          _hoisted_2
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(" Auth Key：" + _toDisplayString(_unref(form).authKey) + " ", 1),
        _createVNode(_unref(aPopover), {
          placement: "right",
          class: "idente_but"
        }, {
          content: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
          ]),
          _: 1
        }),
        _createElementVNode("span", {
          class: "btn_clone rose",
          "data-clipboard-text": _unref(form).authKey,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (Copylist('.rose')))
        }, [
          _createVNode(_component_a_button, {
            size: "small",
            class: "text_clone"
          }, {
            default: _withCtx(() => [
              _createTextVNode("复制")
            ]),
            _: 1
          })
        ], 8, _hoisted_5)
      ]),
      _createElementVNode("div", null, [
        _createTextVNode(" 单点开关： "),
        _createVNode(_unref(aRadioGroup), {
          value: _unref(form).idLoginPoint,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).idLoginPoint) = $event)),
          class: "idente_mar",
          onInput: _cache[4] || (_cache[4] = ($event: any) => (updateForm(2)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio, { value: true }, {
              default: _withCtx(() => [
                _createTextVNode("开启")
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio, { value: false }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createTextVNode(" 功能开关： "),
      _createVNode(_component_a_switch, {
        checked: _unref(form).idGiveSwitch,
        "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).idGiveSwitch) = $event)),
        onChange: _cache[6] || (_cache[6] = ($event: any) => (updateForm(0)))
      }, null, 8, ["checked"]),
      _createVNode(_unref(aPopover), {
        placement: "right",
        class: "idente_but"
      }, {
        content: _withCtx(() => [
          _hoisted_7
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})